import InsightsRevenueLeakageListItem from "./insights-revenue-leakage-list-item";

export default InsightsRevenueLeakageListItem;
